import IconPlus from "@Icons/controls/IconPlus";
import useCurrency from "@Currency/hooks/useCurrency";
import AvailablePassengerClassType from "@CheckOrder/features/classPicker/types/AvailablePassengerClass.type";

interface PassengerClassSelectModalAddNewGroupProps {
    closeModal: () => void,
    selectedPassengerClass: AvailablePassengerClassType | undefined,
    setSelectedPassengerClass: (passengerClass: AvailablePassengerClassType, passengerGroupIndex?: number) => void,
}

function PassengerClassSelectModalAddNewGroup(props: PassengerClassSelectModalAddNewGroupProps) {
    const {
        closeModal,
        selectedPassengerClass,
        setSelectedPassengerClass,
    } = props
    const createNewPassengerGroupForThisPassengerClass = () => {
        setSelectedPassengerClass(selectedPassengerClass)
        closeModal()
    }

    const {val} = useCurrency()

    return (
        <button
            type="button"
            onClick={createNewPassengerGroupForThisPassengerClass}
            className="new-passenger-class"
        >
            <IconPlus
                width="30"
                height="30"
                backgroundFill="transparent"
            />
            <span className="new-passenger-class__cta">
                new Cabin
            </span>
            <span className="new-passenger-class__price">
                {`${selectedPassengerClass.prices[1]} ${val}`}
            </span>
        </button>
    )
}

export default PassengerClassSelectModalAddNewGroup